<div
  [hidden]="!hasOffers"
  class="bottom-bar"
  [lxResponsiveClass]="{ vertical: 'other-options-handset', horizontal: 'other-options-desktop' }">
  <span [hidden]="true" class="bottom-link" (click)="noThanksClicked.emit()">No Thanks →</span>

  @if(offerCount && offerCount > 3) {
    <span
      class="bottom-link accent"
      data-theme-key="--accent"
      [hidden]="selectedTab !== 'ROOM'"
      (click)="viewMoreClicked.emit()">
      {{ viewMoreOrLessText }}
      <i [hidden]="viewMoreToggle" class="fa fa-plus" aria-hidden="true"></i>
      <i [hidden]="!viewMoreToggle" class="fa fa-minus" aria-hidden="true"></i>
    </span>
  }

</div>
